//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolEventPolicyCancellationDeadlineSettingsUpdateItem } from './SchoolEventPolicyCancellationDeadlineSettingsUpdateItem';
import { SchoolMakeUpCreditLimitSettingsUpdateItem } from './SchoolMakeUpCreditLimitSettingsUpdateItem';
import { SchoolEventPolicySignUpSettingsUpdateItem } from './SchoolEventPolicySignUpSettingsUpdateItem';

export class SchoolEventPolicySettingsUpdateItem extends ItemBase {
    CancellationPolicyText?: string | null;
    CancellationDeadlineSettings?: SchoolEventPolicyCancellationDeadlineSettingsUpdateItem | null;
    MakeUpCreditLimitSettings?: SchoolMakeUpCreditLimitSettingsUpdateItem | null;
    MakeUpEventCategoryID?: string | null;
    MakeUpCreditExpiryDays?: number | null;
    SignUpSettings?: SchoolEventPolicySignUpSettingsUpdateItem | null;

    constructor(initializer?: Partial<SchoolEventPolicySettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicySettingsUpdateItem";
}
